// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","445":"1bfc9850","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"4fadfdaa205b480b5957","445":"ed0da0b912d6aa4c90ea","678":"181153d97df35c08effc","883":"4ed8ae3d5d50fc4c5fd6"}[chunkId] + ".js";
};